import { useMutation, useQueryClient } from '@tanstack/react-query';

import { scheduleOrderService, scheduleQueryKeys } from '../infra';

export function useCancelScheduledOrderMutation() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (orderId: number) =>
      scheduleOrderService.delScheduledOrder(orderId),
    onSuccess: () =>
      queryClient.invalidateQueries({
        queryKey: [...scheduleQueryKeys.all, 'list'],
      }),
  });
}
